import { memo, useEffect, useState } from "react"
import { CheckPicker, DateRangePicker, Dropdown } from 'rsuite';
import { Row, Col } from "react-bootstrap"
import { Button, message } from 'antd';
import { format } from "date-fns"
import { Link } from "react-router-dom"
import { headerPillar } from "../../../../enums/headerReport.enum";

const Filter = ({infoPage, storeSelected, setStoreSelected, startDate, setStartDate, endDate, setEndDate, handleExport, axiosService}) => {
    const [storeOptions, setStoreOptions] = useState([]);

    useEffect(() => {
        let isMounted = true;
        const fetchStore = async () => {
            try {
                const res = await axiosService("api/stores", "GET");
                if (!isMounted) return;
                if (res.data.code === 200) {
                    const options = [];
                    const ids = [];

                    res.data.data?.forEach((s) => {
                        options.push({
                            value: s.id,
                            label: s.name_store,
                        });
                        if (s.status === 1) ids.push(s.id);
                    });

                    setStoreOptions(options);
                    setStoreSelected(ids);
                }
            } catch (err) {
                message.error("Lỗi load store");
            }
        };

        fetchStore();

        return () => { isMounted = false; };
    }, []);

    const onChangeDate = (e) => {
        if (e) {
            setStartDate(format(e[0], 'yyyy-MM-dd'))
            setEndDate(format(e[1], 'yyyy-MM-dd'))
        }
    }

    return (
        <div className="search-report">
            <Row className="justify-content-end">
                <Col xs={12} md={4} lg={3} xl={6}>
                    <Dropdown title={infoPage.title} className="mb-2">
                        {headerPillar.map((x, i) => {
                            return (
                                <Link to={{ pathname: `/report/${x.route}` }} key={i}>
                                    <Dropdown.Item >
                                        <i className={`${x.icon} mr-1`}></i><span>{x.label}</span> {infoPage.type === x.route && <i className="ml-2 fa-solid fa-check"></i>}
                                    </Dropdown.Item>
                                </Link>
                            )
                        })}
                    </Dropdown>
                </Col>
                <Col xs={12} md={4} lg={3} xl={2}>
                    <CheckPicker
                        data={storeOptions}
                        value={storeSelected}
                        onChange={setStoreSelected}
                        placeholder="Chọn cơ sở"
                        className="mb-2"
                        style={{width: "300px"}}
                        searchable
                    />
                </Col>
                <Col xs={12} md={4} lg={3} xl={2}>
                    <DateRangePicker
                        className="w-100 mb-2"
                        placement={"bottomEnd"}
                        format="yyyy-MM-dd"
                        onChange={onChangeDate}
                        showOneCalendar={true}
                        defaultValue={[new Date(startDate), new Date(endDate)]}
                        value={[new Date(startDate), new Date(endDate)]}
                    />
                </Col>
                <Col xs={6} md={2} lg={2} xl={2} style={{ textAlign: "right" }} className="mb-2">
                    <Button size="middle" type="primary" onClick={handleExport}>
                        <i className="fa-solid fa-file-excel mr-2"></i>Xuất dữ liệu
                    </Button>
                </Col>
            </Row>
        </div>
    )
}
export default memo(Filter)